import { apiClient } from '../axios-instance';

export interface DocumentCallout {
  type: 'info' | 'warning' | 'important';
  text: string;
}

export interface DocumentSection {
  id: string;
  heading: string;
  paragraphs?: string[];
  bullets?: string[];
  callout?: DocumentCallout;
}

export interface LegalDocumentListItem {
  id: number;
  documentType: 'terms' | 'privacy';
  version: string;
  title: string;
  effectiveDate: string;
  publishedAt: string | null;
  publishedBy: number | null;
  status: 'draft' | 'published' | 'superseded';
  effectiveState: 'draft' | 'scheduled' | 'active' | 'superseded';
  noticeText: string | null;
  requiresReacceptance: boolean;
  changeSummary: string[];
  contentHash: string;
  revision: number;
  sectionsCount: number;
  updatedAt: string;
}

export interface LegalDocumentDetail {
  id: number;
  documentType: 'terms' | 'privacy';
  version: string;
  title: string;
  effectiveDate: string;
  publishedAt: string | null;
  publishedBy: number | null;
  status: 'draft' | 'published' | 'superseded';
  noticeText: string | null;
  requiresReacceptance: boolean;
  changeSummary: string[];
  contentHash: string;
  revision: number;
  sections: DocumentSection[];
  updatedAt: string;
}

export interface LegalDocumentDraftPayload {
  id?: number;
  documentType: 'terms' | 'privacy';
  version: string;
  title: string;
  effectiveDate: string;
  noticeText?: string;
  requiresReacceptance?: boolean;
  changeSummary?: string[];
  sections: DocumentSection[];
  revision?: number;
}

export const legalDocumentsService = {
  getDocuments: async (type?: 'terms' | 'privacy') => {
    const params = type ? { type } : undefined;
    const response = await apiClient.get<{ success: boolean; data: LegalDocumentListItem[] }>('/admin/legal-documents', { params });
    return response.data;
  },

  getDocument: async (id: number) => {
    const response = await apiClient.get<{ success: boolean; data: LegalDocumentDetail }>(`/admin/legal-documents/${id}`);
    return response.data;
  },

  saveDraft: async (payload: LegalDocumentDraftPayload) => {
    const response = await apiClient.post<{ success: boolean; message: string; data: { id: number; revision: number } }>(
      '/admin/legal-documents/draft',
      payload
    );
    return response.data;
  },

  publish: async (id: number, revision?: number) => {
    const response = await apiClient.post<{ success: boolean; message: string }>(
      `/admin/legal-documents/${id}/publish`,
      { revision }
    );
    return response.data;
  },

  deleteDraft: async (id: number) => {
    const response = await apiClient.delete<{ success: boolean; message: string }>(`/admin/legal-documents/${id}`);
    return response.data;
  },
};
